import { createContext } from "react";

// set the defaults
const BannerContext = createContext({ banner: null });

export default BannerContext;
